<template>
  <section class="select-option-component">
    <span class="slide-number title mb-4">
      Slide {{ activity.lesson_slide.order }}
    </span>
    <span class="title font-weight-light mb-2">
      Question
    </span>
    <p class="tab-content-description" v-html="activity.logged_question"></p>
    <span class="title font-weight-light mb-2">
      Answer
    </span>
    <br />
    <span class="title font-weight-light mb-2">
      <v-icon>check_box</v-icon> = Selected by student
    </span>
    <v-row class="mt-4">
      <v-col cols="12" md="6">
        <span class="title font-weight-light">Correct options</span>
        <ul>
          <li v-for="(a, index) in correctAnswer" :key="`dr-${index}`">
            <v-icon :color="a.isSelected ? 'correct' : 'incorrect'">{{
              a.isSelected ? 'check_box' : 'indeterminate_check_box'
            }}</v-icon>
            {{ a.text }}
          </li>
        </ul>
      </v-col>
      <v-col cols="12" md="6">
        <span class="title font-weight-light">Incorrect options</span>
        <ul>
          <li v-for="(a, index) in incorrectAnswer" :key="`dr-${index}`">
            <v-icon :color="a.isSelected ? 'incorrect' : 'correct'">{{
              a.isSelected ? 'check_box' : 'check_box_outline_blank'
            }}</v-icon>
            {{ a.text }}
          </li>
        </ul>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'SelectOptions',
  props: {
    activity: {
      type: Object,
      required: true
    },
    activityIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    correctAnswer() {
      return this.activity.logged_answers.items.filter(val => val.isCorrect)
    },
    incorrectAnswer() {
      return this.activity.logged_answers.items.filter(val => !val.isCorrect)
    }
  }
}
</script>

<style lang="scss">
.select-option-component {
  .slide-number {
    display: block;
    color: var(--v-primary-base);
  }

  ul {
    padding: 0;
    list-style-type: none;
  }
}
</style>
